// extracted by mini-css-extract-plugin
export var barContainer = "_12-0";
export var extraThin = "_12-3";
export var fillBar = "_12-6";
export var fillContainer = "_12-4";
export var overflow = "_12-8";
export var overflowContainer = "_12-5";
export var regular = "_12-7";
export var thick = "_12-1";
export var thin = "_12-2";